import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ALIGN, Corners, EventsService, FooterTypes, ImageRatio, TextPosition } from 'simpo-component-library';
import { DynamicSectionService } from 'src/app/services/dynamicsection.service';
import { EditorEventService } from 'src/app/services/editor-event.service';
import { TemplateService } from 'src/app/services/template.service';
import { TemplateMasterService } from '../../template-master.service';
import { PageData, Section } from '../editor.modal';
import { ComponentListV3Component } from '../../pages/component-list-v3/component-list-v3.component';
import { EventsService as EventService } from 'src/app/services/events.service';
import { EcommerceService } from 'src/app/services/ecomerce.service';
import { EventEmmiterService } from 'simpo-components';

@Component({
  selector: 'app-v3-editor',
  templateUrl: './v3-editor.component.html',
  styleUrls: ['./v3-editor.component.scss']
})
export class V3EditorComponent {
  @ViewChild('displayWebsite', { read: ViewContainerRef })
  displayWebsite: ViewContainerRef | any;

  constructor(private templateService: TemplateMasterService,
    private _router: Router,
    private _snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private eventHelper: EventEmmiterService,
    private websiteGenerationService: DynamicSectionService,
    private eventDirective: EventsService,
    private eventService: EditorEventService,
    private _eventService: EventsService,
    private eventsService: EventService,
    private ecomService: EcommerceService,
    private _templateService: TemplateService
  ) {
    this.getScreenSize()
  }

  screenWidth: any;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.screenWidth = window.innerWidth;
  }

  @Input() templatePage: any[] = []
  @Output() websiteLoaderfun: EventEmitter<boolean> = new EventEmitter();
  @Input() themes: any[] = [];
  @Input() subIndustryId: any;
  @Input() currentPageId?: string;
  @Input() websiteType: 'STATIC' | 'E_COMMERCE' = 'STATIC'
  @Input() isPreview: boolean = false;
  currentPageIndex = 0;
  subscriptionList: any[] = [];
  showEditor: boolean = false;
  editorDirection: any;
  sectionName: any;
  showEditorSectionSubscribe: any;
  listItemIndex: number = 0;
  listItemLabel: string = '';
  textAlign: ALIGN[] = ['left', 'center', 'right']
  imageRatio: ImageRatio[] = []
  textPosition: TextPosition[] = [];
  footerType: FooterTypes[] = []
  corners: Corners[] = [];
  collpaseEditor: boolean = true;
  private currentTabSubscriber?: Subscription;
  private renderedEventService: any = null;
  private libraryToRenderedSubs: Subscription[] = [];

  ngOnInit() {
    // if (this.templatePage.length > 0) {
    //   this.getWebsite()
    // }
    this.currentTabSubscriber = this._templateService.secondaryEditor.subscribe((res: any) => {
      this.activeTab = res.data.tab && res.data.tab != "STYLES" ? res.data.tab : "";
      if (res.data.tab === 'LIST_ITEM') {
        this.listItemIndex = res.data.listItemIndex ?? 0;
        this.listItemLabel = res.data.listItemLabel || 'Items';
      }
      this.templateService.secondaryEditor.emit(res);
    });
    this.enumValue();
    this.addPageEvent()
    this.showEditorSection();
    this.subscribeToSimpoEditorEvents();
  }

  gotoStyles() {
    this._templateService.goBack.emit({ back: true })
    this.activeTab = ""
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.changePageEvent();
  }

  tabsHeading: any = {
    'STYLE': '',
    'LIST_ITEM': 'Item',
    'LOGO_EDITOR': 'Logo',
    'SOCIAL_CHANNEL': 'Social Link',
    'BACKGROUND': 'Colors',
    'BUTTON_STYLE': 'Button style'
  }
  activeTab: string = "";


  showEditorSection() {
    this.showEditorSectionSubscribe = this.eventService.showEditor.subscribe(
      (res: any) => {
        this.showEditor = res.data;
      }
    )
  }

  ngOnDestroy() {
    this.changePageSubscription?.unsubscribe()
    this.addPageSubscription?.unsubscribe()
    this.showEditorSectionSubscribe?.unsubscribe();
    this.currentTabSubscriber?.unsubscribe();
    this.libraryToRenderedSubs.forEach(s => s.unsubscribe());
    this.libraryToRenderedSubs = [];
    this.subscriptionList?.forEach(element => {
      element?.unsubscribe();
    });
  }

  changePageSubscription?: Subscription;
  changePageEvent() {
    this.changePage()
  }


  addPageSubscription?: Subscription;
  addPageEvent() {
    this.addPageSubscription?.unsubscribe()
    this.addPageSubscription = this.eventService.addPageEvent.subscribe((res: any) => {
      this.createNewPage()
    })
  }

  initiateSubscription(instance: any) {
    this.subscriptionList.forEach(element => {
      element.unsubscribe();
    });
    this.renderedEventService = instance;
    this.bridgeLibraryEventsToRendered();

    this.subscriptionList.push(
      instance.addNewSectionClick.subscribe((res: any) => {
        this.addNewSection(res);
      })
    )
    this.subscriptionList.push(
      instance.editSection.subscribe((res: any) => {
        this.showEditor = true;
        setTimeout(() => {
          this.sectionName = res.data.sectionName;
          this.eventsService.editSection.emit({ data: res.data, subIndustryId: this.subIndustryId });
        }, 200)
      })
    )
    this.subscriptionList.push(
      instance.restyleSection.subscribe((res: any) => {
        this.regenerateComponent(res);
      })
    )
    this.subscriptionList.push(
      instance.changeContent.subscribe((res: any) => {
        this.regenerateContent(res);
      })
    )
    this.subscriptionList.push(
      instance.changePosition.subscribe((res: any) => {
        this.changeSectionPosition(res);
      })
    )
    this.subscriptionList.push(
      instance.delete.subscribe((res: any) => {
        this.deleteConfirm(res);
      })
    )
    this.subscriptionList.push(
      instance.duplicate.subscribe((res: any) => {
        this.createDuplicateSection(res);
      })
    )
  }

  addNewSection(response: any) {

    // let sectionWindow = this.templateService.openDialog(ComponentListV3Component, '90%', '50%', {type: this.websiteType
    // });

    let index: number = response.position === 'ABOVE' ? response.index : response.index + 1;
    // sectionWindow.afterClosed().subscribe((res: any) => {
    // if (res?.id) {
    this.AddSkeletonSection(index, response.sectionType);

    this.templateService.getSectionForIndustry(response.componentId, this.subIndustryId).subscribe((component: any) => {

      let componentStyle = this.getThemeStyle();
      component.data.styles.background.color = componentStyle.bgColor;
      component.data.styles.background.accentColor = componentStyle.accentColor;

      // TO CHECK IF ADD SECTION COMPONENT IS PRESENT IN PAGE OR NOT IF YES THEN REMOVING IT
      if ((this.checkCurrentPageIsHomePage() &&
        this.templatePage[0].components[1].sectionType == 'addNewSection' ||
        (!this.checkCurrentPageIsHomePage() && this.templatePage[this.currentPageIndex].components[0].sectionType === 'addNewSection'))) {
        this.templatePage[this.currentPageIndex].components.splice(this.checkCurrentPageIsHomePage() ? index : index - 1, 1, component.data);
        this.displayWebsite.remove(1)
      } else {
        // BECAUSE HEADER AND FOOTER IS PRESENT ONLY IN HOME PAGE NOT IN OTHER PAGE;
        this.templatePage[this.currentPageIndex].components.splice(this.checkCurrentPageIsHomePage() ? index : index - 1, 0, component.data);
      }

      const instance = this.websiteGenerationService.updateSection(this.displayWebsite, index, component.data, true, null, this.subIndustryId);
      this.initiateSubscription(instance);
    })
    // }
    // })

  }

  getThemeStyle() {
    let indexFound = false;
    for (let theme of this.themes) {
      if (theme.id === this.templatePage[this.currentPageIndex].websiteThemeId) {
        indexFound = true;
        let randomIndex = Math.floor(Math.random() * (theme.componentStyles?.length ?? 1));
        let componentStyle = theme.componentStyles[randomIndex];
        return componentStyle;
      }
    }

    if (!indexFound) {
      let randomIndex = Math.floor(Math.random() * (this.themes[0].componentStyle?.length ?? 1));
      let componentStyle = this.themes[0].componentStyles[randomIndex];
      return componentStyle;
    }
  }

  AddSkeletonSection(index: number, sectionType: any) {
    let addSection = new Section();
    addSection.sectionType = 'section-loader';

    const instance = this.websiteGenerationService.addSection(this.displayWebsite, addSection, false, index, sectionType);
    this.initiateSubscription(instance);
  }

  updateSkeletonSection(index: number, sectionType: any) {
    let addSection = new Section();
    addSection.sectionType = 'section-loader';

    const instance = this.websiteGenerationService.updateSection(this.displayWebsite, index, addSection, false, sectionType);
    this.initiateSubscription(instance);
  }

  DeleteSection() {
    console.log(this.deleteResponse);
    let index = this.deleteResponse.index;
    if (!this.checkCurrentPageIsHomePage()) {
      index--;
    }
    this.templatePage[this.currentPageIndex].components.splice(index, 1);

    if ((this.checkCurrentPageIsHomePage() && this.checkHeaderAndFooterOnlyPresent()) ||
      (!this.checkCurrentPageIsHomePage() && this.templatePage[this.currentPageIndex].components.length == 0)) {

      this.templatePage[this.currentPageIndex].components.splice(index, 0, this.createAddSection());
    }

    let sections: Section[] = []
    if (this.checkCurrentPageIsHomePage()) {
      sections = this.templatePage[0].components;
    } else {
      this.addSectionForOtherPage(sections);
    }

    const instance = this.websiteGenerationService.loadDynamicSection(this.displayWebsite, sections, true);
    this.initiateSubscription(instance);


    const openDelete = document.getElementById('deletepopup');
    if (!openDelete) return;
    openDelete.setAttribute("style", "display:none");
  }

  deleteResponse: any;
  deleteConfirm(response: any) {
    this.deleteResponse = response;
    const openDelete = document.getElementById('deletepopup');
    if (!openDelete) return;
    // openDelete.setAttribute("style","display:block");
    openDelete.style.display = "block";
    openDelete.style.backdropFilter = "blur(5px)";
  }

  cancelSection() {
    const openDelete = document.getElementById('deletepopup');
    if (!openDelete) return;
    openDelete.setAttribute("style", "display:none");
  }

  createAddSection() {
    let addSection = new Section();
    addSection.sectionType = 'addNewSection';
    return addSection;
  }

  addSectionForOtherPage(section: Section[]) {
    section.push(this.templatePage[0].components[0]);
    for (let sec of this.templatePage[this.currentPageIndex].components) {
      section.push(sec);
    }
    section.push(this.templatePage[0].components[this.templatePage[0].components.length - 1]);
  }

  checkCurrentPageIsHomePage() {
    return this.templatePage[this.currentPageIndex].pageName === 'Home';
  }

  checkHeaderAndFooterOnlyPresent() {
    if (this.templatePage[0].components.length == 2 && this.templatePage[0].components[0].sectionType === 'header' &&
      this.templatePage[0].components[1].sectionType === 'footer')
      return true;

    return false;
  }

  regenerateContent(response: any) {
    this.updateSkeletonSection(response.index, response.sectionType);
    this.templateService.getSectionContent(response.sectionId, this.subIndustryId).subscribe((res: any) => {
      let index = this.checkCurrentPageIsHomePage() ? response.index : response.index - 1;
      this.templatePage[this.currentPageIndex].components[index].content = res.data.data;
      this.templatePage[this.currentPageIndex].components[index].action = res.data.action;

      const instance = this.websiteGenerationService.updateSection(this.displayWebsite, response.index, this.templatePage[this.currentPageIndex].components[index], true, null, this.subIndustryId);
      this.initiateSubscription(instance)
      this._snackBar.open(
        'Content has been updated successfully',
        'Close',
        {
          duration: 2500,
        }
      )
    })
  }

  changeSectionPosition(response: any) {
    let index = this.checkCurrentPageIsHomePage() ? response.index : response.index - 1;
    let swappedIndex = response.position === 'UP' ? response.index - 1 : response.index + 1;
    let currentPage = this.templatePage[this.currentPageIndex];

    if (currentPage.components[swappedIndex].sectionType === 'footer') {
      return;
    }

    [currentPage.components[index], currentPage.components[swappedIndex]] = [currentPage.components[swappedIndex], currentPage.components[index]];

    const instance = this.websiteGenerationService.loadDynamicSection(this.displayWebsite, this.templatePage[this.currentPageIndex].components, true);
    this.initiateSubscription(instance);
  }

  createDuplicateSection(response: any) {
    this.AddSkeletonSection(response.index + 1, response.data.sectionType);
    this.templateService.getSectionForIndustry(response.data.componentId, this.subIndustryId).subscribe((res: any) => {
      res.data.content = JSON.parse(JSON.stringify(response.data.content));
      res.data.styles = JSON.parse(JSON.stringify(response.data.styles));
      res.data.action = JSON.parse(JSON.stringify(response.data.action));
      this.templatePage[this.currentPageIndex].components.splice(response.index + 1, 0, res.data);

      const instance = this.websiteGenerationService.updateSection(this.displayWebsite, response.index + 1, res.data, true, null, this.subIndustryId);
      this.initiateSubscription(instance);
    })
  }

  enumValue() {
    for (const value of Object.values(ImageRatio)) {
      this.imageRatio.push(value);
    }

    for (const value of Object.values(TextPosition)) {
      this.textPosition.push(value);
    }

    for (const value of Object.values(FooterTypes)) {
      this.footerType.push(value);
    }

    for (const value of Object.values(Corners)) {
      this.corners.push(value);
    }
  }

  regenerateComponent(response: any) {
    let index = this.checkCurrentPageIsHomePage() ? response.index : response.index - 1;
    let component = this.templatePage[this.currentPageIndex].components[index];

    if (component.sectionType === 'banner' || component.sectionType === 'text_image' || component.sectionType === 'contact us') {
      let index = component.styles.positionLayout.types.indexOf(component.styles.positionLayout.value) + 1;
      component.styles.positionLayout.value = component.styles.positionLayout.types[index % component.styles.positionLayout.types.length];
      this.eventDirective.postionLayoutChangeChecks.emit({ id: component.id, data: component.styles.positionLayout })
    }
    if (component.sectionType === 'FAQ' || component.sectionType === 'testimonial' || component.sectionType === 'text') {
      let index = this.textAlign.indexOf(component.styles.layout.align) + 1;
      component.styles.layout.align = this.textAlign[index % this.textAlign.length];
      this.eventDirective.alignmentChangeChecks.emit({ id: component.id, data: component.styles.layout })
    }
    if (component.sectionType === 'imagegrid') {
      if (!component.styles.removeGaps || !component.styles.fullWidth) {
        component.styles.removeGaps = true;
        component.styles.fullWidth = true;

      } else {
        let index = this.imageRatio.indexOf(component.styles.image.ratio) + 1;
        component.styles.image.ratio = this.imageRatio[index % this.imageRatio.length];
        this.eventDirective.imageStyleChangeChecks.emit({ id: component.id, style: component.styles.image })
      }
    }
    if (component.sectionType === 'image') {
      let index = this.corners.indexOf(component.styles.corners) + 1;
      if (component.styles.corners === Corners.None || index <= this.corners.length - 2) {
        component.styles.corners = this.corners[index % this.corners.length];
      } else {
        component.styles.corners = this.corners[index % this.corners.length];
        component.styles.fullWidth = !component.styles.fullWidth
      }
    }
    if (component.sectionType === 'service' || component.sectionType === 'teammember') {
      let index = this.textPosition.indexOf(component.styles.textPosition) + 1;
      component.styles.textPosition = this.textPosition[index % this.textPosition.length];
    }
    if (component.sectionType === 'video') {
      component.styles.fullScreen = !component.styles.fullScreen;
      if (component.styles.layout.fit === 'content') {
        component.styles.layout.fit = 'screen'
      } else {
        component.styles.layout.fit = 'content'
      }
      this.eventDirective.spacingChangeChecks.emit({ id: component.id, data: component.styles.layout })
    }
    if (component.sectionType === 'imageCarousel') {
      let index = this.corners.indexOf(component.styles.corners) + 1;
      component.styles.corners = this.corners[index % this.corners.length];
    }
    if (component.sectionType === 'footer') {
      let index = this.footerType.indexOf(component.styles.footerType) + 1;
      component.styles.footerType = this.footerType[index % this.footerType.length];
    }


  }

  createNewPage() {
    let pageData: PageData = new PageData();
    pageData.path = this.templatePage.length < 2 ? '/New_Page' : '/New_Page_' + String(this.templatePage.length - 1);
    pageData.pageName = this.templatePage.length < 2 ? 'New Page' : ('New Page ' + String(this.templatePage.length - 1));
    pageData.updatedTimeStamp = new Date()
    pageData.homePageId = this.templatePage[0].id
    pageData.id = '';

    pageData.components.push(this.createAddSection())

    this.templatePage.push(pageData);
    this.currentPageIndex = this.templatePage.length - 1;

    let header: Section = this.templatePage[0].components[0];
    let footer: Section = this.templatePage[0].components[this.templatePage[0].components.length - 1];

    let sections: Section[] = [];
    sections.push(header);
    sections.push(this.templatePage[this.currentPageIndex].components[0])
    sections.push(footer);
    const instance = this.websiteGenerationService.loadDynamicSection(this.displayWebsite, sections, true);
    this.initiateSubscription(instance);
  }

  changePage() {
    this.templatePage.forEach((page: PageData, index: number) => {
      if (page.id === this.currentPageId) {
        this.currentPageIndex = index;
      }
    })

    let section: Section[] = [];
    if (this.templatePage[this.currentPageIndex].pageName === 'Home') {
      section = this.templatePage[this.currentPageIndex].components;
    } else {
      this.addSectionForOtherPage(section)
    }
    Promise.all(this.getComponentData(section)).then(() => {
      setTimeout(() => {
        const instance = this.websiteGenerationService.loadDynamicSection(this.displayWebsite, section, this.isPreview ? false : true);
        this.initiateSubscription(instance);
        this.websiteLoaderfun.emit(false)
      }, 500)
    })
  }

  getComponentData(components: any[]) {
    const promises = components.map(async (section, index) => {
      if (section.type === 'E_COMMERCE') {
        let res: any = await this.ecomService.getDummyData(this.subIndustryId, section.sectionType);
        section['responseData'] = res?.data
      }
    });
    return promises;
  }

  private openButtonEditorSubscription?: Subscription;
  private openImageEditorSubscription?: Subscription;
  private openTextEditorSubscription?: Subscription;
  multiTabEditor: boolean = false;

  private subscribeToSimpoEditorEvents(): void {
    this.openButtonEditorSubscription = this.eventDirective.openButtonEditor.subscribe((res: any) => {
      if (!res?.sectionId) return;
      const section = this.findSectionById(res.sectionId);
      if (!section) return;

      this.openEditorForSection(section);

      setTimeout(() => {
        if (res.itemIndex != null && res.itemIndex >= 0) {
          const listItem = this.findListItemInSection(section, res.itemIndex);
          if (!listItem) return;
          this.templateService.secondaryEditor.emit({
            data: { tab: 'LIST_ITEM', listItem, newItem: false }
          });
          return;
        }

        const button = this.findButtonInSection(section, res.buttonId);
        if (!button) return;
        this.templateService.secondaryEditor.emit({
          data: {
            tab: 'BUTTON_EDITOR',
            buttonData: button.content ?? button,
            buttonStyle: button.styles ?? button.buttonStyle ?? section.styles?.buttonStyle,
            componentId: section.id,
            btnId: button.id ?? res.buttonId ?? '',
            color: section.styles?.background?.accentColor ?? '',
            backgroundInfo: section.styles?.background
          }
        });
      }, 400);
    });

    this.openImageEditorSubscription = this.eventDirective.openImageEditor.subscribe((res: any) => {
      if (!res?.sectionId) return;
      const section = this.findSectionById(res.sectionId);
      if (!section) return;

      this.openEditorForSection(section);

      setTimeout(() => {
        if (res.itemIndex != null && res.itemIndex >= 0) {
          const listItem = this.findListItemInSection(section, res.itemIndex);
          if (!listItem) return;
          this.templateService.secondaryEditor.emit({
            data: { tab: 'LIST_ITEM', listItem, newItem: false }
          });
          return;
        }

        const imageData = section.content?.image;
        if (!imageData) return;
        this.templateService.secondaryEditor.emit({
          data: { tab: 'IMAGE_EDITOR', imageData, sectionId: section.id }
        });
      }, 400);
    });

    this.openTextEditorSubscription = this.eventDirective.openTextEditor.subscribe((res: any) => {
      if (!res?.sectionId) return;
      const section = this.findSectionById(res.sectionId);
      if (!section) return;

      this.openEditorForSection(section);

      setTimeout(() => {
        if (res.itemIndex != null && res.itemIndex >= 0) {
          const listItem = this.findListItemInSection(section, res.itemIndex);
          if (!listItem) return;
          this.templateService.secondaryEditor.emit({
            data: { tab: 'LIST_ITEM', listItem, newItem: false }
          });
          return;
        }

        this.templateService.secondaryEditor.emit({ data: { tab: 'STYLE' } });
        const textItem = section.content?.inputText?.[res.inputTextIndex];
        if (textItem) {
          setTimeout(() => {
            this._templateService.focusContentBlock.emit({ blockType: 'text', data: textItem });
          }, 100);
        }
      }, 400);
    });
  }

  private findSectionById(sectionId: string): any {
    const components = this.templatePage[this.currentPageIndex]?.components;
    if (!components) return null;
    return components.find((c: any) => c.id === sectionId) ?? null;
  }

  private findButtonInSection(section: any, buttonId: string): any {
    if (!buttonId || !section?.action?.buttons?.length) return null;
    return (
      section.action.buttons.find((b: any) => b.id === buttonId) ??
      section.action.buttons.find((b: any) => b.content?.id === buttonId) ??
      null
    );
  }

  private findListItemInSection(section: any, itemIndex: number): any {
    const items = section?.content?.listItem?.data;
    if (!Array.isArray(items) || itemIndex >= items.length) return null;
    return items[itemIndex] ?? null;
  }
  sectionData: any;
  private closingEditorTimeout?: ReturnType<typeof setTimeout>;
  isClosingEditor: boolean = false;

  private openEditorForSection(section: any): void {
    if (section.sectionType?.includes('carouselBanner')) {
      this.multiTabEditor = true;
      this.showEditor = false;
      this.sectionData = section;
    } else {
      clearTimeout(this.closingEditorTimeout);
      this.isClosingEditor = false;
      this.showEditor = true;
      this.multiTabEditor = false;
      this.sectionName = section.sectionName;
      setTimeout(() => {
        this.eventHelper.editSection.emit({ data: section });
      }, 200);
    }
  }

  dismiss() {
    this.showEditor = false;
    this.activeTab = "";
  }

  changeEditorDirection(ev) {
    if (ev === 'LEFT') {
      this.editorDirection = 'RIGHT';
    }
    else {
      this.editorDirection = "LEFT";
    }
  }

  private bridgeLibraryEventsToRendered(): void {
    this.libraryToRenderedSubs.forEach(s => s.unsubscribe());
    this.libraryToRenderedSubs = [];

    const eventNames: (keyof typeof this.eventDirective)[] = [
      'backgroundImageChangeCheck',
      'colorOverlayChangeChecks',
      'alignmentChangeChecks',
      'animationChangeChecks',
      'spacingChangeChecks',
      'borderChangeChecks',
      'cardSizeChangeChecks',
      'imageStyleChangeChecks',
      'cornerChangeChecks',
      'textBackgroundChangeChecks',
      'buttonStyleChangeChecks',
      'postionLayoutChangeChecks',
      'contentAlignmentChangeCheck'
    ];

    eventNames.forEach((eventName: any) => {
      const libraryEmitter = (this.eventDirective as any)[eventName];
      if (libraryEmitter?.subscribe) {
        const sub: Subscription = libraryEmitter.subscribe((data: any) => {
          if (this.renderedEventService && this.renderedEventService !== this.eventDirective) {
            const renderedEmitter = this.renderedEventService[eventName];
            if (renderedEmitter?.emit) {
              renderedEmitter.emit(data);
            }
          }
        });
        this.libraryToRenderedSubs.push(sub);
      }
    });
  }

}
